import { motion } from 'framer-motion';
import { Car, Navigation, Shield, Calendar, BarChart3, MessageSquare, Settings, Headphones } from 'lucide-react';
import { useWebsite } from '../../contexts/WebsiteContext';

const solutions = [
  {
    icon: Car,
    title: "Fleet Management",
    description: "Comprehensive luxury vehicle fleet management with real-time monitoring and maintenance scheduling"
  },
  {
    icon: Navigation,
    title: "GPS Tracking",
    description: "Advanced GPS tracking system for your entire fleet with real-time location updates"
  },
  {
    icon: Shield,
    title: "Professional Storage",
    description: "Secure, climate-controlled storage facilities for your premium vehicles"
  },
  {
    icon: Calendar,
    title: "Events Management",
    description: "Organize and manage track days, corporate events, and exclusive private gatherings"
  },
  {
    icon: BarChart3,
    title: "Business Intelligence",
    description: "Comprehensive analytics and reporting dashboard for data-driven decisions"
  },
  {
    icon: MessageSquare,
    title: "Communication Hub",
    description: "Integrated messaging system for seamless client and team communication"
  },
  {
    icon: Settings,
    title: "Marketing Integration",
    description: "Built-in marketing tools and social media management capabilities"
  },
  {
    icon: Headphones,
    title: "AI Support",
    description: "24/7 AI-powered customer support with voice and text capabilities"
  }
];

export default function ComprehensiveSolutions() {
  return (
    <section className="py-24 bg-black">
      <div className="max-w-[90%] 2xl:max-w-[1800px] mx-auto px-4 sm:px-6">
        <motion.h2 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-400 mb-16"
        >
          Comprehensive Luxury Solutions
          <p className="body-jaguar text-gray-400 text-sm max-w-2xl mx-auto">
            To give you full control on all areas of your business
          </p>
        </motion.h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
          {solutions.map((solution, index) => {
            const Icon = solution.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                whileHover={{ 
                  scale: 1.02,
                  boxShadow: "0 0 30px 0 rgba(251, 191, 36, 0.1)",
                }}
                transition={{ 
                  type: "spring",
                  stiffness: 300,
                  damping: 20,
                  delay: index * 0.1 
                }}
                className="p-6 rounded-2xl bg-zinc-900/50 border border-zinc-800 
                           hover:border-amber-500/30 hover:bg-zinc-800/70
                           backdrop-blur-lg transition-all duration-300"
              >
                <motion.div 
                  className="mb-4"
                  whileHover={{ scale: 1.1 }}
                  transition={{ type: "spring", stiffness: 400, damping: 17 }}
                >
                  <Icon className="w-12 h-12 text-amber-400" />
                </motion.div>
                <motion.h3 
                  className="text-xl font-semibold text-white mb-2"
                  whileHover={{ scale: 1.05, x: 10 }}
                  transition={{ type: "spring", stiffness: 400, damping: 17 }}
                >
                  {solution.title}
                </motion.h3>
                <p className="text-gray-400">
                  {solution.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
} 